module.exports = __webpack_public_path__ + "img/adapt.b554f88a.png";